import { getBrandList, getSeriesList } from '@this/services/brand';
import localStorage from '@/utils/localStorage';

const state = {
  brandList: [],
  hotBrandList: [],
  brandSelected: {},
  showMoreBrand: false,
  seriesList: [],
  seriesSelected: {},
  showMoreSeries: false,
  intentionBrandList: [],
};

const mutations = {
  setBrandList(state, list) {
    state.brandList = list;
  },
  setIntentionBrandList(state, list) {
    state.intentionBrandList = list;
  },
  setHotBrandList(state, list) {
    state.hotBrandList = list;
  },
  setBrandSelected(state, obj) {
    state.brandSelected = obj;
  },
  setShowMoreBrand(state, bool) {
    state.showMoreBrand = bool;
  },
  setSeriesList(state, list) {
    state.seriesList = list;
  },
  setSeriesSelected(state, obj) {
    state.seriesSelected = obj;
  },
  setShowMoreSeries(state, bool) {
    state.showMoreSeries = bool;
  },
};

const HOT_KEY = '热门品牌';

const getters = {
  isMore(state) {
    const hasBrandSelected = state.brandSelected.pcauto_id > 0;
    const hasFindIndex = state.hotBrandList.findIndex((item) => item.pcauto_id === state.brandSelected.pcauto_id) > -1;
    return hasBrandSelected && !hasFindIndex;
  },
};

const actions = {
  async initBrand({ dispatch }) {
    const hotBrand = [15, 2, 69, 21, 24, 633, 396, 113, 5];
    const intentionBrandList = [2, 3, 20, 1, 4, 10, 15, 21, 7, 13, 225];
    await dispatch('getBrandList', hotBrand);
    dispatch('getIntentionBrandList', intentionBrandList);
    dispatch('getHotBrandList', [2, 3, 10, 4, 20, 1]);
  },
  getBrandList({ commit, dispatch }, brandIDs) {
    const localBrandList = localStorage.get('brandList');
    if (localBrandList) {
      commit('setBrandList', localBrandList);
      return;
    }
    return getBrandList().then(async (res) => {
      const hotBrandList = await dispatch('findHotBrandList', {
        brandList: res.data,
        brandIDs,
      });
      const brandList = [
        {
          key: HOT_KEY,
          list: hotBrandList,
        },
        ...res.data,
      ].map((item) => {
        item.shortKey = item.key.substr(0, 1);
        return item;
      });
      localStorage.set('brandList', brandList);
      commit('setBrandList', brandList);
    });
  },
  async getIntentionBrandList({ commit, dispatch }, brandIDs) {
    const hotBrandList = await dispatch('findHotBrandList', {
      brandIDs,
    });
    commit('setIntentionBrandList', hotBrandList);
  },
  async getHotBrandList({ commit, dispatch }, brandIDs) {
    const hotBrandList = await dispatch('findHotBrandList', {
      brandIDs,
    });
    commit('setHotBrandList', hotBrandList);
  },
  findHotBrandList({ state }, { brandList, brandIDs }) {
    const thisBrandList = brandList || state.brandList;
    const hotBrandList = [];
    thisBrandList.forEach((item) => {
      item.list.forEach((subItem) => {
        if (item.key !== HOT_KEY && brandIDs.indexOf(subItem.pcauto_id) > -1) {
          hotBrandList.push(subItem);
        }
      });
    });
    return hotBrandList;
  },
  clickBrand({ commit, dispatch }, item) {
    commit('setBrandSelected', item);
    dispatch('changeShowMoreBrand', false);
  },
  changeShowMoreBrand({ commit, state }, bool) {
    const showMoreBrand = bool ?? !state.showMoreBrand;
    commit('setShowMoreBrand', showMoreBrand);
  },
  async clickBrandGetSeriesList({ commit, dispatch }, brand) {
    commit('setBrandSelected', brand);
    await dispatch('getSeriesList', brand.pcauto_id);
    dispatch('changeShowMoreSeries', true);
  },
  getSeriesList({ commit }, brandID) {
    return getSeriesList({
      pc_brand_id: brandID,
    }).then((res) => {
      commit('setSeriesList', res.data);
    });
  },
  clickSeries({ commit, dispatch }, series) {
    commit('setSeriesSelected', series);
    dispatch('changeShowMoreSeries');
    dispatch('changeShowMoreBrand');
  },
  changeShowMoreSeries({ commit, state }, bool) {
    const showMoreSeries = bool ?? !state.showMoreSeries;
    commit('setShowMoreSeries', showMoreSeries);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
